var RequestHelper = /** @class */ (function () {
    function RequestHelper() {
    }
    RequestHelper.convertToFormData = function (object) {
        var formData = new FormData();
        Object.keys(object).filter(function (key) { return object[key] !== null; }).forEach(function (key) {
            var value = object[key];
            if (Array.isArray(value)) {
                for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                    var item = value_1[_i];
                    formData.append("".concat(key, "[]"), item);
                }
                return;
            }
            formData.append(key, value);
        });
        return formData;
    };
    return RequestHelper;
}());
export { RequestHelper };
export default RequestHelper;
